import { CustomerResource, ListResource, Recipient } from 'services/resources';
import request from '../../request';

/**
 * Returns the customers list
 */
export function query(limit: number, offset: number, filters: URLSearchParams, search: string) {
  const params = {
    limit: limit.toString(),
    offset: offset.toString(),
    search,
  };
  const urlParams = new URLSearchParams(params);

  for (const [key, val] of filters.entries()) {
    urlParams.append(key, val);
  }

  return request<ListResource<CustomerResource>>(`fleet/customers/`, {
    method: 'GET',
    params: urlParams,
  });
}

/**
 * Returns a customer with the given id
 */
export function find(id) {
  return request<CustomerResource>(`fleet/customers/${id}/`, {
    method: 'GET',
  });
}

/**
 * Updates part of the customer resource
 */
export function patch(id, customer) {
  return request<CustomerResource>(`fleet/customers/${id}/`, {
    method: 'PATCH',
    data: customer,
  });
}

/**
 * Add new customer
 */

export function post(customer) {
  return request<CustomerResource>('fleet/customers/', {
    method: 'POST',
    data: customer,
  });
}

/**
 * Adds a new note for the customer
 */
export function createNote(customerId, note) {
  return request(`fleet/customers/${customerId}/notes/`, {
    method: 'POST',
    data: {
      customer: customerId,
      note,
    },
  });
}

/**
 * Update a note
 */
export function patchNote(customerId, note) {
  return request(`fleet/customers/${customerId}/notes/`, {
    method: 'PATCH',
    data: {
      ...note,
    },
  });
}

/**
 * Gets the customer vehicles
 */
export function vehicles(customerId) {
  return request(`common/vehicles/?customer=${customerId}`, {
    method: 'GET',
  });
}

/**
 * Returns the customer's history list
 */
export function getHistory(id, filter) {
  return request(`fleet/customers/${id}/history/?category=${filter}`, {
    method: 'GET',
  });
}

/**
 * Gets the customer default creditcard
 */
export function getDefaultCreditcard(id) {
  return request(`fleet/customers/${id}/default_creditcard/`, {
    method: 'GET',
  });
}

export function sendStripePortalLink(id: number, recipient: Recipient) {
  return request<{ url?: string }>(`fleet/customers/${id}/customer_portal_link/`, {
    method: 'POST',
    data: recipient,
  });
}

export function postCustomerChecking(id: number, recipient: Recipient) {
  return request(`fleet/customers/${id}/request_customer_checkin/`, {
    method: 'POST',
    data: recipient,
  });
}
